import { bootstrapApplication } from '@angular/platform-browser';
import { APP_API_NAME } from '@nomoh-monorepo/shared-data-access-environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    { provide: APP_API_NAME, useValue: 'bardo' }, // ✅ API Bardo
  ],
}).catch((err) => console.error(err));
//fake commit
